
import { useState } from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Plus, MapPin } from "lucide-react";
import { CityForm } from "./CityForm";
import { CityList } from "./city-management/CityList";
import { CityStats } from "./city-management/CityStats";
import { useCityData } from "./city-management/useCityData";

export function CityManagement() {
  const { cities, organizations, loading, fetchCities, handleDelete } = useCityData();
  const [isCreateDialogOpen, setIsCreateDialogOpen] = useState(false);

  const handleCreateSuccess = () => {
    setIsCreateDialogOpen(false);
    fetchCities();
  };

  const handleEditSuccess = () => {
    fetchCities();
  };

  if (loading) {
    return (
      <Card>
        <CardHeader style={{ backgroundColor: 'orange' }}>
          <CardTitle className="flex items-center gap-2">
            <MapPin className="h-5 w-5" />
            City Management
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="text-center py-4">Loading cities...</div>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card>
      <CardHeader style={{ backgroundColor: 'orange' }}>
        <CardTitle className="flex items-center gap-2">
          <MapPin className="h-5 w-5" />
          City Management
        </CardTitle>
        <CardDescription>
          Manage cities for flight destinations
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="flex justify-between items-center mb-4">
          <CityStats totalCities={cities.length} />
          <Dialog open={isCreateDialogOpen} onOpenChange={setIsCreateDialogOpen}>
            <DialogTrigger asChild>
              <Button>
                <Plus className="h-4 w-4 mr-2" />
                Add City
              </Button>
            </DialogTrigger>
            <DialogContent>
              <DialogHeader>
                <DialogTitle>Create New City</DialogTitle>
              </DialogHeader>
              <CityForm 
                organizations={organizations}
                onSubmit={handleCreateSuccess}
              />
            </DialogContent>
          </Dialog>
        </div>

        <CityList
          cities={cities}
          organizations={organizations}
          onEdit={handleEditSuccess}
          onDelete={handleDelete}
        />
      </CardContent>
    </Card>
  );
}
